(() => {

    const Main = {

        init() {
            Main.authPanels();
            Main.moduleToolbar();
            Main.repeatableRows();
            Main.figmaSearch();
            Main.runStatusPoll();
            Main.severityFilter();
            Main.pagesToggle();
        },

        /**
         * New-run form: show only the fields of the selected login type.
         * Panels declare the types they belong to via data-auth-panel="form,otp".
         */
        authPanels() {
            const radios = document.querySelectorAll('input[name="auth_type"]');
            if (!radios.length) return;

            const panels = document.querySelectorAll('[data-auth-panel]');
            const apply = () => {
                const selected = document.querySelector('input[name="auth_type"]:checked');
                const type = selected ? selected.value : 'none';
                panels.forEach(panel => {
                    panel.hidden = !panel.dataset.authPanel.split(',').includes(type);
                });
            };
            radios.forEach(radio => radio.addEventListener('change', apply));
            apply();
        },

        /**
         * New-run form: select all / none / default set over the module checkboxes.
         */
        moduleToolbar() {
            const buttons = document.querySelectorAll('.modules-select');
            if (!buttons.length) return;

            const boxes = document.querySelectorAll('input[name="modules"]');
            buttons.forEach(button => {
                button.addEventListener('click', () => {
                    const mode = button.dataset.select;
                    const defaults = (button.dataset.defaultModules || '').split(',');
                    boxes.forEach(box => {
                        box.checked = mode === 'all' || (mode === 'default' && defaults.includes(box.value));
                    });
                });
            });
        },

        /**
         * New-run form: repeatable input rows (extra headers, Figma mapping).
         * A .repeat-rows container holds .repeat-row entries, an .add-repeat-row button
         * and a <template> with the blank row; removal is delegated.
         */
        repeatableRows() {
            document.querySelectorAll('.repeat-rows').forEach(container => {
                const template = container.querySelector('template');
                const addButton = container.querySelector('.add-repeat-row');
                addButton.addEventListener('click', () => {
                    container.insertBefore(template.content.cloneNode(true), addButton);
                    const rows = container.querySelectorAll('.repeat-row');
                    rows[rows.length - 1].querySelector('input').focus();
                });
                container.addEventListener('click', event => {
                    const remove = event.target.closest('.remove-repeat-row');
                    if (remove) remove.closest('.repeat-row').remove();
                });
            });
        },

        /**
         * New-run form: find a Figma file by name through the API and fill the file-key input.
         */
        figmaSearch() {
            const input = document.getElementById('id-figma-search');
            if (!input) return;

            const results = document.querySelector('.figma-search-results');
            const target = document.getElementById('id-figma-file');
            const note = text => {
                results.innerHTML = '';
                const item = document.createElement('li');
                item.className = 'is-note';
                item.textContent = text;
                results.append(item);
                results.hidden = false;
            };
            const render = files => {
                results.innerHTML = '';
                files.forEach(file => {
                    const item = document.createElement('li');
                    const button = document.createElement('button');
                    button.type = 'button';
                    const name = document.createElement('span');
                    name.textContent = file.name;
                    const project = document.createElement('small');
                    project.textContent = file.project;
                    button.append(name, project);
                    button.addEventListener('click', () => {
                        target.value = file.key;
                        input.value = file.name;
                        results.hidden = true;
                    });
                    item.append(button);
                    results.append(item);
                });
                results.hidden = false;
            };
            const search = () => {
                note('Searching…');
                fetch(`${input.dataset.figmaSearchUrl}?q=${encodeURIComponent(input.value.trim())}`)
                    .then(response => response.json().then(data => ({ ok: response.ok, data })))
                    .then(({ ok, data }) => {
                        if (!ok) {
                            note(data.error || 'Search failed.');
                        } else if (!data.files.length) {
                            note('No files matched.');
                        } else {
                            render(data.files);
                        }
                    })
                    .catch(() => note('Search failed — network or server error.'));
            };
            document.querySelector('.figma-search-go').addEventListener('click', search);
            input.addEventListener('keydown', event => {
                if (event.key !== 'Enter') return;
                event.preventDefault();
                search();
            });
        },

        /**
         * Report page: poll status.json while the run is queued/running/waiting;
         * update the live counters in place and reload when the status changes.
         */
        runStatusPoll() {
            const root = document.querySelector('[data-run-status-url]');
            if (!root) return;

            const initial = root.dataset.runState;
            const tick = () => {
                fetch(root.dataset.runStatusUrl)
                    .then(response => response.json())
                    .then(data => {
                        if (data.status !== initial) {
                            window.location.reload();
                            return;
                        }
                        ['pages', 'modules_done', 'findings'].forEach(key => {
                            const counter = root.querySelector(`[data-live="${key}"]`);
                            if (counter) counter.textContent = data[key];
                        });
                        setTimeout(tick, 2500);
                    })
                    .catch(() => setTimeout(tick, 5000));
            };
            setTimeout(tick, 2500);
        },

        /**
         * Report page: severity chips toggle finding rows across every findings table.
         */
        severityFilter() {
            const filters = document.querySelectorAll('.sev-filter');
            if (!filters.length) return;

            filters.forEach(filter => {
                filter.addEventListener('click', () => {
                    const pressed = filter.getAttribute('aria-pressed') === 'true';
                    filter.setAttribute('aria-pressed', String(!pressed));
                    document.querySelectorAll(`tr[data-severity="${filter.dataset.severity}"]`).forEach(row => {
                        row.hidden = pressed;
                    });
                });
            });
        },

        /**
         * Report page: expand/collapse all collapsibles of the button's own section
         * (Pages and AI review each have their own toolbar).
         */
        pagesToggle() {
            const buttons = document.querySelectorAll('.pages-toggle');
            if (!buttons.length) return;

            buttons.forEach(button => {
                button.addEventListener('click', () => {
                    const scope = button.closest('section') || document;
                    scope.querySelectorAll('.report-page').forEach(details => {
                        details.open = button.dataset.toggle === 'open';
                    });
                });
            });
        }
    };

    Main.init();
})();
